/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import history from '@modules/utils/history'
import { handleUnauthorizedAction } from '@modules/auth/auth'

import { getConfigForKey } from '../../selectors'

import type { ReduxState } from '@/types/redux'

export function unauthorized(currentLocation: Location) {
  return (_dispatch, getState: () => ReduxState) => {
    const state = getState()

    const isHeroku = getConfigForKey(state, `APP_FAMILY`) === `heroku`

    handleUnauthorizedAction({
      isHeroku,
      location: currentLocation,
      setLocation: (redirectUrl) => history.replace(redirectUrl),
    })
  }
}
